<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'TutorBillingModalHeader',
})

withDefaults(defineProps<{
  title: string
  subtitle?: string | null
  note?: string | null
  badge?: string | null
}>(), {
  subtitle: null,
  note: null,
  badge: null,
})
</script>

<template>
  <div class="tutor-billing-modal-header">
    <span
      v-if="badge"
      class="tutor-billing-modal-header__badge"
    >
      <span class="tutor-billing-modal-header__badge-dot" />
      {{ badge }}
    </span>
    <AppText
      name="h2"
      color="slate-900"
    >
      {{ title }}
    </AppText>
    <AppText
      v-if="subtitle"
      name="body1"
      color="slate-500"
    >
      {{ subtitle }}
    </AppText>
    <AppText
      v-if="note"
      name="body1"
      color="slate-500"
      class="tutor-billing-modal-header__note"
    >
      {{ note }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./TutorBillingModalHeader.scss" />
